export default class HomeClass {
    static init() {
    	// alert('onInit HomeClass');
    }

    static finalize() {
    	// alert('onLoad HomeClass');
    }

}